/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_config_file_to_db_settings_opcos__opco_id__config_validation_rules_post } from '../models/Body_config_file_to_db_settings_opcos__opco_id__config_validation_rules_post';
import type { Body_upload_bulk_user_users_upload_bulk_user_post } from '../models/Body_upload_bulk_user_users_upload_bulk_user_post';
import type { Body_upload_data_settings_upload_opcos_post } from '../models/Body_upload_data_settings_upload_opcos_post';
import type { ClientValidationRuleUpdate } from '../models/ClientValidationRuleUpdate';
import type { CurrentUserRead } from '../models/CurrentUserRead';
import type { DeletedAttribute } from '../models/DeletedAttribute';
import type { EmailRequest } from '../models/EmailRequest';
import type { GroupingOptions } from '../models/GroupingOptions';
import type { LdapLoginRequest } from '../models/LdapLoginRequest';
import type { OpcoConfigValidationRule } from '../models/OpcoConfigValidationRule';
import type { OpCoValidationRuleRead } from '../models/OpCoValidationRuleRead';
import type { OpCoValidationRuleUpdate } from '../models/OpCoValidationRuleUpdate';
import type { OperatingCompanyCreate } from '../models/OperatingCompanyCreate';
import type { OperatingCompanyRead } from '../models/OperatingCompanyRead';
import type { OperatingCompanyUpdate } from '../models/OperatingCompanyUpdate';
import type { PasswordResetRequest } from '../models/PasswordResetRequest';
import type { RolesBelowResponse } from '../models/RolesBelowResponse';
import type { SignInRequest } from '../models/SignInRequest';
import type { SignupRequest } from '../models/SignupRequest';
import type { TeamMetrics } from '../models/TeamMetrics';
import type { TeamsCreate } from '../models/TeamsCreate';
import type { TeamsDetailRead } from '../models/TeamsDetailRead';
import type { TeamsUpdate } from '../models/TeamsUpdate';
import type { UserCreateRequest } from '../models/UserCreateRequest';
import type { UserDetailRead } from '../models/UserDetailRead';
import type { UserEmailRequest } from '../models/UserEmailRequest';
import type { UserMetrics } from '../models/UserMetrics';
import type { UserTeamMappingResponse } from '../models/UserTeamMappingResponse';
import type { UserTeamMappingUpdate } from '../models/UserTeamMappingUpdate';
import type { UserUpdateRequest } from '../models/UserUpdateRequest';
import type { ValidationRuleCreate } from '../models/ValidationRuleCreate';
import type { ValidationRuleDependency } from '../models/ValidationRuleDependency';
import type { ValidationRuleRead } from '../models/ValidationRuleRead';
import type { WorkQueuesCreate } from '../models/WorkQueuesCreate';
import type { WorkQueuesRead } from '../models/WorkQueuesRead';
import type { WorkQueuesUpdate } from '../models/WorkQueuesUpdate';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SettingsService {

    /**
     * Get All Validation Rules
     * @param limit
     * @param offset
     * @returns ValidationRuleRead Successful Response
     * @throws ApiError
     */
    public static getAllValidationRulesSettingsValidationRulesAllGet(
        limit?: (number | null),
        offset?: (number | null),
    ): CancelablePromise<Array<ValidationRuleRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/settings/validation_rules/all',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Validation Rule
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns ValidationRuleRead Successful Response
     * @throws ApiError
     */
    public static createValidationRuleSettingsValidationRulesCreatePost(
        requestBody: ValidationRuleCreate,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<ValidationRuleRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/settings/validation_rules/create',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Validation Rule
     * @param id
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns ValidationRuleRead Successful Response
     * @throws ApiError
     */
    public static updateValidationRuleSettingsValidationRulesIdUpdatePatch(
        id: number,
        requestBody: ClientValidationRuleUpdate,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<ValidationRuleRead> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/settings/validation_rules/{id}/update',
            path: {
                'id': id,
            },
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Workqueues All
     * @param restrictToCurrentUser
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns WorkQueuesRead Successful Response
     * @throws ApiError
     */
    public static getWorkqueuesAllSettingsWorkqueuesAllGet(
        restrictToCurrentUser: boolean = false,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<WorkQueuesRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/settings/workqueues/all',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'restrict_to_current_user': restrictToCurrentUser,
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Workqueue
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns WorkQueuesRead Successful Response
     * @throws ApiError
     */
    public static createWorkqueueSettingsWorkqueuesCreatePost(
        requestBody: WorkQueuesCreate,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<WorkQueuesRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/settings/workqueues/create',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Modify Workqueue
     * @param id
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns WorkQueuesRead Successful Response
     * @throws ApiError
     */
    public static modifyWorkqueueSettingsWorkqueuesIdUpdatePatch(
        id: number,
        requestBody: WorkQueuesUpdate,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<WorkQueuesRead> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/settings/workqueues/{id}/update',
            path: {
                'id': id,
            },
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Workqueue
     * @param id
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns DeletedAttribute Successful Response
     * @throws ApiError
     */
    public static deleteWorkqueueSettingsWorkqueuesIdDeleteDelete(
        id: number,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<DeletedAttribute> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/settings/workqueues/{id}/delete',
            path: {
                'id': id,
            },
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Team
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns TeamsDetailRead Successful Response
     * @throws ApiError
     */
    public static createTeamSettingsTeamsCreatePost(
        requestBody: TeamsCreate,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<TeamsDetailRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/settings/teams/create',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Modify Team
     * @param id
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns TeamsDetailRead Successful Response
     * @throws ApiError
     */
    public static modifyTeamSettingsTeamsIdUpdatePatch(
        id: number,
        requestBody: TeamsUpdate,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<TeamsDetailRead> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/settings/teams/{id}/update',
            path: {
                'id': id,
            },
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Team
     * @param id
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns DeletedAttribute Successful Response
     * @throws ApiError
     */
    public static deleteTeamSettingsTeamsIdDeleteDelete(
        id: number,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<DeletedAttribute> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/settings/teams/{id}/delete',
            path: {
                'id': id,
            },
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get All Teams
     * @param limit
     * @param offset
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns TeamsDetailRead Successful Response
     * @throws ApiError
     */
    public static getAllTeamsSettingsTeamsAllGet(
        limit?: (number | null),
        offset?: (number | null),
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<TeamsDetailRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/settings/teams/all',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get All Opco Validation Rules
     * @param opcoId
     * @param limit
     * @param offset
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns OpCoValidationRuleRead Successful Response
     * @throws ApiError
     */
    public static getAllOpcoValidationRulesSettingsOpcoValidationRulesAllGet(
        opcoId?: (number | null),
        limit?: (number | null),
        offset?: (number | null),
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<OpCoValidationRuleRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/settings/opco_validation_rules/all',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'opco_id': opcoId,
                'limit': limit,
                'offset': offset,
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get All Validation Rule Dependencies
     * @param ruleId
     * @param limit
     * @param offset
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns ValidationRuleDependency Successful Response
     * @throws ApiError
     */
    public static getAllValidationRuleDependenciesSettingsValidationruleDependenciesAllGet(
        ruleId?: (number | null),
        limit?: (number | null),
        offset?: (number | null),
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<ValidationRuleDependency>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/settings/validationrule_dependencies/all',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'rule_id': ruleId,
                'limit': limit,
                'offset': offset,
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Opco Config Validation
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns OpcoConfigValidationRule Successful Response
     * @throws ApiError
     */
    public static getOpcoConfigValidationSettingsGetOpcoConfigValidationGet(
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<OpcoConfigValidationRule>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/settings/get_opco_config_validation',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Opco Validation Rule
     * @param id
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns OpCoValidationRuleRead Successful Response
     * @throws ApiError
     */
    public static updateOpcoValidationRuleSettingsOpcoValidationRulesIdUpdatePatch(
        id: number,
        requestBody: OpCoValidationRuleUpdate,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<OpCoValidationRuleRead> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/settings/opco_validation_rules/{id}/update',
            path: {
                'id': id,
            },
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Opco
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns OperatingCompanyRead Successful Response
     * @throws ApiError
     */
    public static createOpcoSettingsOpcoPost(
        requestBody: OperatingCompanyCreate,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<OperatingCompanyRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/settings/opco',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Read Opco
     * @param limit
     * @param offset
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns OperatingCompanyRead Successful Response
     * @throws ApiError
     */
    public static readOpcoSettingsOpcoGet(
        limit?: number,
        offset?: number,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<OperatingCompanyRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/settings/opco',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Opco
     * @param opcoId
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns OperatingCompanyRead Successful Response
     * @throws ApiError
     */
    public static updateOpcoSettingsOpcoOpcoIdPatch(
        opcoId: number,
        requestBody: OperatingCompanyUpdate,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<OperatingCompanyRead> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/settings/opco/{opco_id}',
            path: {
                'opco_id': opcoId,
            },
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Opco
     * @param opcoId
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns DeletedAttribute Successful Response
     * @throws ApiError
     */
    public static deleteOpcoSettingsOpcoOpcoIdDelete(
        opcoId: number,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<DeletedAttribute> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/settings/opco/{opco_id}',
            path: {
                'opco_id': opcoId,
            },
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Read Opco
     * @param opcoId
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns OperatingCompanyRead Successful Response
     * @throws ApiError
     */
    public static readOpcoSettingsOpcoOpcoIdGet(
        opcoId: number,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<OperatingCompanyRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/settings/opco/{opco_id}',
            path: {
                'opco_id': opcoId,
            },
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Download Template
     * @returns any Successful Response
     * @throws ApiError
     */
    public static downloadTemplateSettingsDownloadOpcoTemplateGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/settings/download_opco_template',
        });
    }

    /**
     * Upload Data
     * @param formData
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns any Successful Response
     * @throws ApiError
     */
    public static uploadDataSettingsUploadOpcosPost(
        formData: Body_upload_data_settings_upload_opcos_post,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/settings/upload_opcos',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Download Config Validation Rule Template
     * @param opcoId
     * @param validationId
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns any Successful Response
     * @throws ApiError
     */
    public static downloadConfigValidationRuleTemplateSettingsDownloadFromGcsGet(
        opcoId: number,
        validationId: number,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/settings/download_from_gcs',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'opco_id': opcoId,
                'validation_id': validationId,
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Config File To Db
     * @param opcoId
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    public static configFileToDbSettingsOpcosOpcoIdConfigValidationRulesPost(
        opcoId: number,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
        formData?: Body_config_file_to_db_settings_opcos__opco_id__config_validation_rules_post,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/settings/opcos/{opco_id}/config_validation_rules',
            path: {
                'opco_id': opcoId,
            },
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Config Validation Rules
     * Get config validation rules for a specific opco and validation rule.
     * Returns all matching config validation rule entries ordered by id.
     * @param opcoId Operating company ID
     * @param validationId Validation rule ID
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getConfigValidationRulesSettingsConfigValidationRulesGet(
        opcoId: number,
        validationId: number,
    ): CancelablePromise<Array<Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/settings/config_validation_rules',
            query: {
                'opco_id': opcoId,
                'validation_id': validationId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Iban Registry
     * Get IBAN registry mapping country codes to IBAN lengths.
     * Returns a dictionary mapping countrycode to iban_length.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getIbanRegistrySettingsIbanRegistryGet(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/settings/iban_registry',
        });
    }

    /**
     * Return Current User
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns CurrentUserRead Successful Response
     * @throws ApiError
     */
    public static returnCurrentUserUsersMeGet(
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<CurrentUserRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/me',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Signup
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static signupUsersRegisterPost(
        requestBody: SignupRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users/register',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Signin
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static signinUsersLoginPost(
        requestBody: SignInRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Refresh Token
     * @returns any Successful Response
     * @throws ApiError
     */
    public static refreshTokenUsersRefreshTokenPost(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users/refresh_token',
        });
    }

    /**
     * Request Temp Password Internal
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static requestTempPasswordInternalUsersRequestTempPasswordInternalPost(
        requestBody: EmailRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users/request-temp-password_internal',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Request Temp Password
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static requestTempPasswordUsersRequestTempPasswordPost(
        requestBody: EmailRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users/request-temp-password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Login With Temp Password
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static loginWithTempPasswordUsersLoginWithTempPasswordPost(
        requestBody: SignInRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users/login-with-temp-password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Login Modes
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getLoginModesUsersLoginModesGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/login-modes',
        });
    }

    /**
     * Logout
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns any Successful Response
     * @throws ApiError
     */
    public static logoutUsersLogoutPost(
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users/logout',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Forgot Password
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static forgotPasswordUsersForgotPasswordPost(
        requestBody: EmailRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users/forgot-password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Validate Forgot Password
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static validateForgotPasswordUsersValidateForgotPasswordPost(
        requestBody: SignInRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users/validate-forgot-password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Login
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static loginUsersLdapLoginPost(
        requestBody: LdapLoginRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users/ldap_login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Metadata
     * @param clientOnboardId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static metadataUsersMetadataGet(
        clientOnboardId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/metadata',
            query: {
                'client_onboard_id': clientOnboardId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Sso Login
     * @returns any Successful Response
     * @throws ApiError
     */
    public static ssoLoginUsersSsoLoginGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/sso/login',
        });
    }

    /**
     * Sso Callback
     * @returns any Successful Response
     * @throws ApiError
     */
    public static ssoCallbackUsersSsoCallbackPost(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users/sso/callback',
        });
    }

    /**
     * Sso Token
     * @param xRefreshToken
     * @param refreshToken
     * @returns any Successful Response
     * @throws ApiError
     */
    public static ssoTokenUsersSsoTokenGet(
        xRefreshToken?: string,
        refreshToken?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/sso/token',
            cookies: {
                'refreshToken': refreshToken,
            },
            headers: {
                'X-Refresh-Token': xRefreshToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Validate User Email
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static validateUserEmailUsersValidateUserEmailPost(
        requestBody: UserEmailRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users/validate-user-email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Oauth Login
     * @returns any Successful Response
     * @throws ApiError
     */
    public static oauthLoginUsersOauthLoginGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/oauth/login',
        });
    }

    /**
     * Oauth Callback
     * @param code
     * @param state
     * @returns any Successful Response
     * @throws ApiError
     */
    public static oauthCallbackUsersOauthCallbackGet(
        code: string,
        state: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/oauth/callback',
            query: {
                'code': code,
                'state': state,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Return All Teams Users Detailed
     * @param limit
     * @param offset
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns UserDetailRead Successful Response
     * @throws ApiError
     */
    public static returnAllTeamsUsersDetailedUsersTeamsUsersAllGet(
        limit?: (number | null),
        offset?: (number | null),
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<UserDetailRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/teams_users_all',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Return All Users Detailed
     * @param limit
     * @param offset
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns UserDetailRead Successful Response
     * @throws ApiError
     */
    public static returnAllUsersDetailedUsersAllGet(
        limit?: (number | null),
        offset?: (number | null),
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<UserDetailRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/all',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create User
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createUserUsersCreateUserPost(
        requestBody: UserCreateRequest,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users/create-user',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Edit User
     * @param userId
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns any Successful Response
     * @throws ApiError
     */
    public static editUserUsersEditUpdatePatch(
        userId: number,
        requestBody: UserUpdateRequest,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/users/edit/update',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'user_id': userId,
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update User Team Mapping
     * Update team assignments for a specific user
     * @param userId
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns any Successful Response
     * @throws ApiError
     */
    public static updateUserTeamMappingUsersTeamMappingUserIdPatch(
        userId: number,
        requestBody: UserTeamMappingUpdate,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/users/team-mapping/{user_id}',
            path: {
                'user_id': userId,
            },
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Users For Team Mapping
     * Get all users with their current team assignments for team mapping screen
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns UserTeamMappingResponse Successful Response
     * @throws ApiError
     */
    public static getUsersForTeamMappingUsersTeamMappingGet(
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<UserTeamMappingResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/team-mapping',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Upload Bulk User
     * @param formData
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns any Successful Response
     * @throws ApiError
     */
    public static uploadBulkUserUsersUploadBulkUserPost(
        formData: Body_upload_bulk_user_users_upload_bulk_user_post,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users/upload_bulk_user',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Roles Below Me
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns RolesBelowResponse Successful Response
     * @throws ApiError
     */
    public static getRolesBelowMeUsersRolesBelowMeGet(
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<RolesBelowResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/roles-below-me',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Download Bulk Templates
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns any Successful Response
     * @throws ApiError
     */
    public static downloadBulkTemplatesUsersTemplateDownloadGet(
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/template_download',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Reset Password Endpoint
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static resetPasswordEndpointUsersResetPasswordPost(
        requestBody: PasswordResetRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users/reset_password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get User Performance
     * @param startDate YYYY-MM-DD, inclusive
     * @param endDate YYYY-MM-DD, inclusive
     * @param grouping Grouping for the data
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns UserMetrics Successful Response
     * @throws ApiError
     */
    public static getUserPerformanceMetricsPerformanceUserGet(
        startDate: string,
        endDate: string,
        grouping: GroupingOptions,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<UserMetrics>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/metrics/performance/user',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'grouping': grouping,
                'start_date': startDate,
                'end_date': endDate,
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Team Performance
     * @param teamId
     * @param startDate YYYY-MM-DD, inclusive
     * @param endDate YYYY-MM-DD, inclusive
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns TeamMetrics Successful Response
     * @throws ApiError
     */
    public static getTeamPerformanceMetricsPerformanceTeamGet(
        teamId: number,
        startDate: string,
        endDate: string,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<TeamMetrics>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/metrics/performance/team',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'team_id': teamId,
                'start_date': startDate,
                'end_date': endDate,
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
